import { useTranslation } from '@thoughtspot/i18n';
import { Modal, ModalSize } from '@thoughtspot/radiant-react/widgets/modal';
import React from 'react';
import { ApplicationSettingsTranslationKeys as Keys } from '../constants';
export const ResetConfirmModal = ({ isOpen, onConfirm, onDismiss, }) => {
    const { t } = useTranslation();
    return (React.createElement(Modal, { isOpen: isOpen, onDismiss: onDismiss, size: ModalSize.XSMALL, title: t(Keys.RESET_MODAL_TITLE), dismissButton: {
            text: t(Keys.CANCEL),
            onClick: onDismiss,
        }, confirmButton: {
            text: t(Keys.RESET_MODAL_CONFIRM),
            onConfirm,
        }, modalTestId: "reset-confirm-modal" },
        React.createElement("span", null, t(Keys.RESET_MODAL_BODY))));
};
//# sourceMappingURL=reset-confirm-modal.js.map